var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCritical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3031_45899)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8936 4.96391C12.4942 4.31025 11.5382 4.33007 11.1662 4.99971L2.82455 20.0147C2.45425 20.6812 2.93622 21.5003 3.6987 21.5003H21.2161C21.9971 21.5003 22.4766 20.6452 22.0694 19.9788L12.8936 4.96391ZM10.9992 10.5003C10.9992 9.94801 11.4469 9.5003 11.9992 9.5003C12.5515 9.5003 12.9992 9.94801 12.9992 10.5003V15.5003C12.9992 16.0526 12.5515 16.5003 11.9992 16.5003C11.4469 16.5003 10.9992 16.0526 10.9992 15.5003V10.5003ZM11.9992 17.5003C11.4469 17.5003 10.9992 17.948 10.9992 18.5003C10.9992 19.0526 11.4469 19.5003 11.9992 19.5003C12.5515 19.5003 12.9992 19.0526 12.9992 18.5003C12.9992 17.948 12.5515 17.5003 11.9992 17.5003Z",
    fill: "#D02F44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3031_45899"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCritical);
export default __webpack_public_path__ + "static/media/critical.3ab0cefe2e56e88edb86c577926a3675.svg";
export { ForwardRef as ReactComponent };